export const IMAGE_SIZE = '256';

/**
 * Appends the resizing query param to the image url.
 */
export const getImageUrlWithResizing = (imageUrl: string): string => {
  try {
    const url = new URL(imageUrl);
    if (!url.searchParams.has('d') && (url.protocol === 'http:' || url.protocol === 'https:')) {
      url.searchParams.append('d', IMAGE_SIZE);
      return url.toString();
    }
    return imageUrl;
  } catch (e) {
    return imageUrl;
  }
};
